import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const links = [
  { label: "Why cash flow", target: "#why" },
  { label: "What you'll learn", target: "#learn" },
  { label: "Who it's for", target: "#who" },
];

export default function HeaderNav({ onNavigate }) {
  return (
    <motion.header
      initial={{ y: -64, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 inset-x-0 z-50 border-b border-slate-200/70 bg-white/70 backdrop-blur-xl"
      data-testid="header-nav"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <button
          onClick={() => onNavigate("#top")}
          className="flex items-center gap-2"
          data-testid="header-logo-button"
        >
          <img src="/eyb-logo.webp" alt="EYB Consulting" className="h-9 w-auto" />
        </button>

        <nav className="hidden md:flex items-center gap-8" data-testid="header-nav-links">
          {links.map((l) => (
            <button
              key={l.target}
              onClick={() => onNavigate(l.target)}
              className="text-sm font-medium text-slate-600 hover:text-[#0FA3E8] transition-colors duration-200"
              data-testid={`nav-link-${l.target.slice(1)}`}
            >
              {l.label}
            </button>
          ))}
        </nav>

        <button
          onClick={() => onNavigate("#register")}
          className="group inline-flex items-center gap-2 rounded-full bg-[#0B2B4B] px-5 py-2.5 text-xs font-bold uppercase tracking-[0.12em] text-white transition-colors duration-200 hover:bg-[#0FA3E8] active:scale-[0.97]"
          data-testid="header-register-btn"
        >
          Register
          <ArrowRight className="h-3.5 w-3.5 transition-transform duration-200 group-hover:translate-x-0.5" />
        </button>
      </div>
    </motion.header>
  );
}
